module.exports = __webpack_public_path__ + "media/landing_page/google-play-icon-d1b2d4e2.svg";